/* eslint-disable @typescript-eslint/ban-types */
import React, { useReducer } from 'react';
import { ExceptionView, IApplicationComponentRef, IApplicationTab, Obsolescence, ReducerActionMap } from '../types';
import { RoadmapAction } from '../types/roadmapAction.type';

/**
 *  TYPES DECLARATION
 */

export type PERIOD_VIEW = 'LAST_THREE_MONTHS' | 'ALL';
export type SETTINGS_VIEW = 'OWNER_VIEW' | 'GENERAL_VIEW' | 'CLAIM_VIEW' | 'CERTIFIED_VIEW';

enum Types {
  /*
   * CLAIM_MODAL
   */
  OPEN_CLAIM_MODAL = 'OPEN_CLAIM_MODAL',
  CLOSE_CLAIM_MODAL = 'CLOSE_CLAIM_MODAL',
  /*
   *	SETTINGS_MODAL
   */
  OPEN_SETTINGS_MODAL = 'OPEN_SETTINGS_MODAL',
  CLOSE_SETTINGS_MODAL = 'CLOSE_SETTINGS_MODAL',
  /*
   * ROADMAP MODAL
   */
  OPEN_ROADMAP_MODAL = 'OPEN_ROADMAP_MODAL',
  CLOSE_ROADMAP_MODAL = 'CLOSE_ROADMAP_MODAL',
  OPEN_ROADMAP_ACTION_MODAL = 'OPEN_ROADMAP_ACTION_MODAL',
  CLOSE_ROADMAP_ACTION_MODAL = 'CLOSE_ROADMAP_ACTION_MODAL',
  /*
   * CERTIFICATION_ERROR_MODAL
   */
  OPEN_CERTIFICATION_ERROR_MODAL = 'OPEN_CERTIFICATION_ERROR_MODAL',
  CLOSE_CERTIFICATION_ERROR_MODAL = 'CLOSE_CERTIFICATION_ERROR_MODAL',
  /*
   * TAG_MODAL
   */
  OPEN_TAG_MODAL = 'OPEN_TAG_MODAL',
  CLOSE_TAG_MODAL = 'CLOSE_TAG_MODAL',
  /*
   * REMOVE_EXCEPTION_MODAL
   */
  OPEN_REMOVE_EXCEPTION_MODAL = 'OPEN_REMOVE_EXCEPTION_MODAL',
  CLOSE_REMOVE_EXCEPTION_MODAL = 'CLOSE_REMOVE_EXCEPTION_MODAL',
  /*
   * REMOVE_ROADMAP_MODAL
   */
  OPEN_REMOVE_ROADMAP_MODAL = 'OPEN_REMOVE_ROADMAP_MODAL',
  CLOSE_REMOVE_ROADMAP_MODAL = 'CLOSE_REMOVE_ROADMAP_MODAL',
  /*
   * REMOVE_TAG_MODAL
   */
  OPEN_REMOVE_TAG_MODAL = 'OPEN_REMOVE_TAG_MODAL',
  CLOSE_REMOVE_TAG_MODAL = 'CLOSE_REMOVE_TAG_MODAL',
  /*
   * REMOVE_BOOKMARK_MODAL
   */
  OPEN_REMOVE_BOOKMARK_MODAL = 'OPEN_REMOVE_BOOKMARK_MODAL',
  CLOSE_REMOVE_BOOKMARK_MODAL = 'CLOSE_REMOVE_BOOKMARK_MODAL',
  /*
   * SCOPE_MODAL
   */
  OPEN_SCOPE_MODAL = 'OPEN_SCOPE_MODAL',
  CLOSE_SCOPE_MODAL = 'CLOSE_SCOPE_MODAL',
  /*
   * TOTAL_COST_MODAL
   */
  OPEN_COST_MODAL = 'OPEN_COST_MODAL',
  CLOSE_COST_MODAL = 'CLOSE_COST_MODAL',
  /*
   * BOOKMARK_MODAL
   */
  OPEN_BOOKMARK_MODAL = 'OPEN_BOOKMARK_MODAL',
  CLOSE_BOOKMARK_MODAL = 'CLOSE_BOOKMARK_MODAL',
  /*
   * CONFIRM_MODAL
   */
  CLOSE_CONFIRM_MODAL = 'CLOSE_CONFIRM_MODAL',
  OPEN_CONFIRM_MODAL = 'OPEN_CONFIRM_MODAL',
  /*
   *	VIEWS
   */
  SET_SETTINGS_VIEW = 'SET_SETTINGS_VIEW',
  SET_PERIOD_VIEW = 'SET_PERIOD_VIEW',
  /*
   * TAG
   */
  SET_TAG_NAMES = 'SET_TAG_NAMES',
  /*
   *	FILTERS
   */
  TOGGLE_FILTERS = 'TOGGLE_FILTERS',
  SET_FILTERS = 'SET_FILTERS',
  /*
   *	BOOKMARK
   */
  TOGGLE_BOOKMARK = 'TOGGLE_BOOKMARK',
  SET_BOOKMARK = 'SET_BOOKMARK',
  /*
   *	SHARE BOOKMARK
   */
  OPEN_SHARE_BOOKMARK_MODAL = 'OPEN_SHARE_BOOKMARK_MODAL',
  CLOSE_SHARE_BOOKMARK_MODAL = 'CLOSE_SHARE_BOOKMARK_MODAL',
  /*
   * TABS
   */
  SET_ITEMS = 'SET_ITEMS',
  OPEN_TAB = 'OPEN_TAB',
  CLOSE_TAB = 'CLOSE_TAB',
  HYDRATE_TABS = 'HYDRATE_TABS',
  /*
   *	PROFILE SETTING UPDATE
   */
  OPEN_EDIT_PROFILE_MODAL = 'OPEN_EDIT_PROFILE_MODAL',
  CLOSE_EDIT_PROFILE_MODAL = 'CLOSE_EDIT_PROFILE_MODAL',
  /**
   * OBSOLESCENCE EDIT MODAL
   */
  OPEN_EDIT_OBSOLESCENCE_MODAL = 'OPEN_EDIT_OBSOLESCENCE_MODAL',
  CLOSE_EDIT_OBSOLESCENCE_MODAL = 'CLOSE_EDIT_OBSOLESCENCE_MODAL',
  /**
   * EXCEPTION EDIT MODAL
   */
  OPEN_EDIT_EXCEPTION_MODAL = 'OPEN_EDIT_EXCEPTION_MODAL',
  CLOSE_EDIT_EXCEPTION_MODAL = 'CLOSE_EDIT_EXCEPTION_MODAL',
}

type UIPayload = {
  [Types.SET_ITEMS]: {
    items: Item[];
  };
  [Types.OPEN_CLAIM_MODAL]: {};
  [Types.CLOSE_CLAIM_MODAL]: {};
  [Types.SET_SETTINGS_VIEW]: {
    view: SETTINGS_VIEW;
  };
  [Types.OPEN_ROADMAP_MODAL]: {};
  [Types.OPEN_ROADMAP_ACTION_MODAL]: {
    roadmapId: number | undefined;
    actions: Array<RoadmapAction>;
  };

  [Types.CLOSE_ROADMAP_MODAL]: {};
  [Types.CLOSE_ROADMAP_ACTION_MODAL]: {};
  [Types.OPEN_EDIT_EXCEPTION_MODAL]: {
    componentRef: IApplicationComponentRef;
    recommendationIds: number[] | undefined;
    exception: ExceptionView | undefined;
  };
  [Types.CLOSE_EDIT_EXCEPTION_MODAL]: {};
  [Types.OPEN_CERTIFICATION_ERROR_MODAL]: {
    componentStatusIds: number[];
    componentIds: number[];
  };

  [Types.CLOSE_CERTIFICATION_ERROR_MODAL]: {};
  [Types.OPEN_TAG_MODAL]: {};

  [Types.CLOSE_TAG_MODAL]: {};
  [Types.OPEN_REMOVE_EXCEPTION_MODAL]: {
    exceptionId: number | undefined;
  };
  [Types.CLOSE_REMOVE_EXCEPTION_MODAL]: {};
  [Types.OPEN_REMOVE_ROADMAP_MODAL]: {
    roadmapId: number | undefined;
  };
  [Types.CLOSE_REMOVE_ROADMAP_MODAL]: {};
  [Types.OPEN_REMOVE_TAG_MODAL]: {
    tagId: number | undefined;
  };
  [Types.CLOSE_REMOVE_TAG_MODAL]: {};
  [Types.OPEN_REMOVE_BOOKMARK_MODAL]: {
    bookmarkId: number | undefined;
  };
  [Types.CLOSE_REMOVE_BOOKMARK_MODAL]: {};
  [Types.OPEN_SETTINGS_MODAL]: {
    view: SETTINGS_VIEW;
  };
  [Types.CLOSE_SETTINGS_MODAL]: {};
  [Types.OPEN_SCOPE_MODAL]: {
    applicationId: number | null | undefined;
    applicationName: string | null | undefined;
    scope: string | null | undefined;
    parent: string | null | undefined;
    date: string | null | undefined;
  };
  [Types.CLOSE_SCOPE_MODAL]: {};
  [Types.OPEN_COST_MODAL]: {
    applicationId: string | null | undefined;
    applicationName: string | null | undefined;
  };
  [Types.CLOSE_COST_MODAL]: {};
  [Types.OPEN_BOOKMARK_MODAL]: {
    userId: number;
    query: string;
  };
  [Types.CLOSE_BOOKMARK_MODAL]: {};
  [Types.SET_PERIOD_VIEW]: {
    periodView: PERIOD_VIEW;
  };
  [Types.SET_TAG_NAMES]: {
    tagNames: string[];
  };
  [Types.HYDRATE_TABS]: {
    tabs: IApplicationTab[];
  };
  [Types.OPEN_TAB]: {
    applicationId: number;
    applicationName: string;
  };
  [Types.CLOSE_TAB]: {
    applicationId: number;
  };
  [Types.CLOSE_CONFIRM_MODAL]: {};
  [Types.OPEN_CONFIRM_MODAL]: {
    applicationId: number;
    applicationName: string;
  };
  [Types.TOGGLE_FILTERS]: {};
  [Types.TOGGLE_BOOKMARK]: {};
  [Types.OPEN_SHARE_BOOKMARK_MODAL]: {
    bookmarkId: number | undefined;
    url: string | undefined;
  };
  [Types.CLOSE_SHARE_BOOKMARK_MODAL]: {};
  [Types.SET_FILTERS]: {
    isOpen: boolean;
  };
  [Types.SET_BOOKMARK]: {
    isOpen: boolean;
  };
  [Types.OPEN_EDIT_PROFILE_MODAL]: {
    userId: number | undefined;
  };
  [Types.CLOSE_EDIT_PROFILE_MODAL]: {};
  [Types.OPEN_EDIT_OBSOLESCENCE_MODAL]: {
    obsolescenceFlat: Obsolescence.ObsolescenceFlat | undefined;
    reference: Obsolescence.Reference | undefined;
    componentRefId: number | undefined;
    versionId: number | undefined;
  };
  [Types.CLOSE_EDIT_OBSOLESCENCE_MODAL]: {};
};

type UIActions = ReducerActionMap<UIPayload>[keyof ReducerActionMap<UIPayload>];

type Item = {
  id: string;
  isOpen: boolean;
  children: string[] | undefined;
};

type InitialStateType = {
  items: Item[] | undefined;
  tagNames: string[];
  showFilters: boolean;
  showBookmarks: boolean;
  periodView: PERIOD_VIEW;
  claimModal: {
    isOpen: boolean;
  };
  evolutionCostsModal: {
    isOpen: boolean;
  };
  roadmapActionModal: {
    isOpen: boolean;
    roadmapId: number | undefined;
    actions: Array<RoadmapAction>;
  };
  certificationErrorModal: {
    isOpen: boolean;
    componentStatusIds: number[];
    componentIds: number[];
  };
  tagModal: {
    isOpen: boolean;
  };
  removeExceptionModal: {
    isOpen: boolean;
    exceptionId: number | undefined;
  };
  removeRoadmapModal: {
    isOpen: boolean;
    roadmapId: number | undefined;
  };
  removeTagModal: {
    isOpen: boolean;
    tagId: number | undefined;
  };
  removeBookmarkModal: {
    isOpen: boolean;
    bookmarkId: number | undefined;
  };
  settingsModal: {
    isOpen: boolean;
    view: SETTINGS_VIEW;
  };
  applicationModal: {
    isOpen: boolean;
    applicationId: number | null | undefined;
    applicationName: string | null | undefined;
    scope: string | null | undefined;
    parent: string | null | undefined;
    date: string | null | undefined;
  };
  bookmarkModal: {
    isOpen: boolean;
    userId: number | undefined;
    query: string | undefined;
  };
  costModal: {
    applicationId: string | null | undefined;
    isOpen: boolean;
    applicationName: string | null | undefined;
  };
  tabs: IApplicationTab[];
  confirmModal: {
    isVisible: boolean;
    applicationId: number | undefined;
    applicationName: string | undefined;
  };
  bookmarksShareModal: {
    isOpen: boolean;
    bookmarkId: number | undefined;
    url: string | undefined;
  };
  profileEditModal: {
    isOpen: boolean;
    userId: number | undefined;
  };
  profileEditNotificationLevelModal: {
    isOpen: boolean;
    userId: number | undefined;
  };
  editObsolescenceModal: {
    isOpen: boolean;
    obsolescenceFlat: Obsolescence.ObsolescenceFlat | undefined;
    reference: Obsolescence.Reference | undefined;
    versionId: number | undefined;
    componentRefId: number | undefined;
  };
};

const initialState: InitialStateType = {
  items: undefined,
  tagNames: [],
  showFilters: false,
  showBookmarks: false,
  periodView: 'LAST_THREE_MONTHS',
  claimModal: {
    isOpen: false,
  },
  evolutionCostsModal: {
    isOpen: false,
  },
  roadmapActionModal: {
    isOpen: false,
    roadmapId: undefined,
    actions: [],
  },
  certificationErrorModal: {
    isOpen: false,
    componentIds: [],
    componentStatusIds: [],
  },
  tagModal: {
    isOpen: false,
  },
  removeExceptionModal: {
    isOpen: false,
    exceptionId: undefined,
  },
  removeRoadmapModal: {
    isOpen: false,
    roadmapId: undefined,
  },
  removeTagModal: {
    isOpen: false,
    tagId: undefined,
  },
  removeBookmarkModal: {
    isOpen: false,
    bookmarkId: undefined,
  },
  settingsModal: {
    isOpen: false,
    view: 'GENERAL_VIEW',
  },
  applicationModal: {
    isOpen: false,
    applicationId: undefined,
    applicationName: undefined,
    scope: undefined,
    parent: undefined,
    date: undefined,
  },
  bookmarkModal: {
    isOpen: false,
    userId: undefined,
    query: undefined,
  },
  costModal: {
    applicationId: undefined,
    isOpen: false,
    applicationName: undefined,
  },
  tabs: [],
  confirmModal: {
    isVisible: false,
    applicationId: undefined,
    applicationName: undefined,
  },
  bookmarksShareModal: {
    isOpen: false,
    bookmarkId: undefined,
    url: undefined,
  },
  profileEditModal: {
    isOpen: false,
    userId: undefined,
  },
  profileEditNotificationLevelModal: {
    isOpen: false,
    userId: undefined,
  },
  editObsolescenceModal: {
    isOpen: false,
    obsolescenceFlat: undefined,
    reference: undefined,
    versionId: undefined,
    componentRefId: undefined,
  },
};

const UIContext = React.createContext<
  | {
      state: InitialStateType;
    }
  | any
>({
  state: initialState,
});

UIContext.displayName = 'UIContext';

export const UIReducer = (state: InitialStateType, action: UIActions): InitialStateType => {
  switch (action.type) {
    case Types.SET_ITEMS: {
      const { items } = action.payload;

      return {
        ...state,
        items,
      };
    }
    case Types.OPEN_CLAIM_MODAL: {
      return {
        ...state,
        claimModal: {
          isOpen: true,
        },
      };
    }
    case Types.CLOSE_CLAIM_MODAL: {
      return {
        ...state,
        claimModal: {
          isOpen: false,
        },
      };
    }
    case Types.SET_SETTINGS_VIEW: {
      const { view } = action.payload;
      return {
        ...state,
        settingsModal: {
          ...state.settingsModal,
          view,
        },
      };
    }
    case Types.OPEN_ROADMAP_ACTION_MODAL: {
      const { roadmapId, actions } = action.payload;

      return {
        ...state,
        roadmapActionModal: {
          isOpen: true,
          roadmapId,
          actions,
        },
      };
    }
    case Types.CLOSE_ROADMAP_ACTION_MODAL: {
      return {
        ...state,
        roadmapActionModal: {
          isOpen: false,
          roadmapId: undefined,
          actions: [],
        },
      };
    }
    case Types.OPEN_CERTIFICATION_ERROR_MODAL: {
      const { componentIds, componentStatusIds } = action.payload;

      return {
        ...state,
        certificationErrorModal: {
          isOpen: true,
          componentIds,
          componentStatusIds,
        },
      };
    }
    case Types.CLOSE_CERTIFICATION_ERROR_MODAL: {
      return {
        ...state,
        certificationErrorModal: {
          isOpen: false,
          componentIds: [],
          componentStatusIds: [],
        },
      };
    }
    case Types.OPEN_TAG_MODAL: {
      return {
        ...state,
        tagModal: {
          isOpen: true,
        },
      };
    }
    case Types.CLOSE_TAG_MODAL: {
      return {
        ...state,
        tagModal: {
          isOpen: false,
        },
      };
    }
    case Types.OPEN_REMOVE_ROADMAP_MODAL: {
      const { roadmapId } = action.payload;
      return {
        ...state,
        removeRoadmapModal: {
          isOpen: true,
          roadmapId,
        },
      };
    }
    case Types.CLOSE_REMOVE_ROADMAP_MODAL: {
      return {
        ...state,
        removeRoadmapModal: {
          isOpen: false,
          roadmapId: undefined,
        },
      };
    }
    case Types.OPEN_REMOVE_EXCEPTION_MODAL: {
      const { exceptionId } = action.payload;
      return {
        ...state,
        removeExceptionModal: {
          isOpen: true,
          exceptionId,
        },
      };
    }
    case Types.CLOSE_REMOVE_EXCEPTION_MODAL: {
      return {
        ...state,
        removeExceptionModal: {
          isOpen: false,
          exceptionId: undefined,
        },
      };
    }
    case Types.OPEN_REMOVE_TAG_MODAL: {
      const { tagId } = action.payload;
      return {
        ...state,
        removeTagModal: {
          isOpen: true,
          tagId,
        },
      };
    }
    case Types.CLOSE_REMOVE_TAG_MODAL: {
      return {
        ...state,
        removeTagModal: {
          isOpen: false,
          tagId: undefined,
        },
      };
    }
    case Types.OPEN_REMOVE_BOOKMARK_MODAL: {
      const { bookmarkId } = action.payload;
      return {
        ...state,
        removeBookmarkModal: {
          isOpen: true,
          bookmarkId,
        },
      };
    }
    case Types.CLOSE_REMOVE_BOOKMARK_MODAL: {
      return {
        ...state,
        removeBookmarkModal: {
          isOpen: false,
          bookmarkId: undefined,
        },
      };
    }
    case Types.OPEN_SETTINGS_MODAL: {
      const { view } = action.payload;
      return {
        ...state,
        settingsModal: {
          isOpen: true,
          view,
        },
      };
    }
    case Types.CLOSE_SETTINGS_MODAL: {
      return {
        ...state,
        settingsModal: {
          ...state.settingsModal,
          isOpen: false,
        },
      };
    }
    case Types.SET_TAG_NAMES: {
      const { tagNames } = action.payload;

      return {
        ...state,
        tagNames,
      };
    }
    case Types.SET_PERIOD_VIEW: {
      const { periodView } = action.payload;

      return {
        ...state,
        periodView: periodView,
      };
    }
    case Types.TOGGLE_FILTERS: {
      return {
        ...state,
        showFilters: !state.showFilters,
      };
    }
    case Types.TOGGLE_BOOKMARK: {
      return {
        ...state,
        showBookmarks: !state.showBookmarks,
      };
    }
    case Types.SET_BOOKMARK: {
      const { isOpen } = action.payload;

      return {
        ...state,
        showBookmarks: isOpen,
      };
    }
    case Types.OPEN_SHARE_BOOKMARK_MODAL: {
      const { bookmarkId, url } = action.payload;

      return {
        ...state,
        bookmarksShareModal: {
          isOpen: true,
          bookmarkId,
          url,
        },
      };
    }
    case Types.CLOSE_SHARE_BOOKMARK_MODAL: {
      return {
        ...state,
        bookmarksShareModal: {
          isOpen: false,
          bookmarkId: undefined,
          url: undefined,
        },
      };
    }
    case Types.OPEN_EDIT_PROFILE_MODAL: {
      const { userId } = action.payload;

      return {
        ...state,
        profileEditModal: {
          isOpen: true,
          userId,
        },
      };
    }
    case Types.CLOSE_EDIT_PROFILE_MODAL: {
      return {
        ...state,
        profileEditModal: {
          isOpen: false,
          userId: undefined,
        },
      };
    }
    case Types.SET_FILTERS: {
      const { isOpen } = action.payload;

      return {
        ...state,
        showFilters: isOpen,
      };
    }
    case Types.HYDRATE_TABS: {
      const { tabs } = action.payload;

      const filteredTabs: IApplicationTab[] = tabs.filter(
        (applicationTab, index, self) =>
          self.findIndex((a) => a.appId === applicationTab.appId || a.appName === applicationTab.appName) === index
      );

      return {
        ...state,
        tabs: filteredTabs,
      };
    }
    case Types.CLOSE_CONFIRM_MODAL: {
      return {
        ...state,
        confirmModal: {
          isVisible: false,
          applicationId: undefined,
          applicationName: undefined,
        },
      };
    }
    case Types.OPEN_CONFIRM_MODAL: {
      return {
        ...state,
        confirmModal: {
          isVisible: true,
          applicationId: action.payload.applicationId,
          applicationName: action.payload.applicationName,
        },
      };
    }
    case Types.OPEN_TAB: {
      const { tabs } = state;
      const { applicationId, applicationName } = action.payload;

      let updatedTabs;

      if (tabs.some((tab) => tab.appId === applicationId)) {
        updatedTabs = tabs.map((tab) => {
          if (tab.appId === applicationId) {
            return {
              ...tab,
            };
          } else {
            return tab;
          }
        });
      } else {
        updatedTabs = [
          ...tabs,
          {
            applicationId,
            appName: applicationName,
          },
        ];
      }

      return {
        ...state,
        tabs: updatedTabs,
      };
    }
    case Types.CLOSE_TAB: {
      const { tabs } = state;
      const { applicationId } = action.payload;

      const filteredTabs = tabs.filter((applicationTab) => applicationTab.appId !== applicationId);

      return {
        ...state,
        tabs: filteredTabs,
        confirmModal: {
          isVisible: false,
          applicationId: undefined,
          applicationName: undefined,
        },
      };
    }
    case Types.OPEN_SCOPE_MODAL: {
      return {
        ...state,
        applicationModal: {
          isOpen: true,
          applicationId: action.payload.applicationId,
          applicationName: action.payload.applicationName,
          scope: action.payload.scope,
          parent: action.payload.parent,
          date: action.payload.date,
        },
      };
    }
    case Types.CLOSE_SCOPE_MODAL: {
      return {
        ...state,
        applicationModal: {
          isOpen: false,
          applicationId: undefined,
          applicationName: undefined,
          scope: undefined,
          parent: undefined,
          date: undefined,
        },
      };
    }
    case Types.OPEN_COST_MODAL: {
      const { applicationName, applicationId } = action.payload;

      return {
        ...state,
        costModal: {
          isOpen: true,
          applicationId,
          applicationName,
        },
      };
    }
    case Types.CLOSE_COST_MODAL: {
      const { costModal } = state;

      return {
        ...state,
        costModal: {
          ...costModal,
          isOpen: false,
        },
      };
    }
    case Types.OPEN_BOOKMARK_MODAL: {
      return {
        ...state,
        bookmarkModal: {
          isOpen: true,
          userId: action.payload.userId,
          query: action.payload.query,
        },
      };
    }
    case Types.CLOSE_BOOKMARK_MODAL: {
      return {
        ...state,
        bookmarkModal: {
          isOpen: false,
          userId: undefined,
          query: undefined,
        },
      };
    }

    case Types.OPEN_EDIT_OBSOLESCENCE_MODAL: {
      const { obsolescenceFlat, versionId, reference, componentRefId } = action.payload;

      return {
        ...state,
        editObsolescenceModal: {
          isOpen: true,
          obsolescenceFlat,
          versionId,
          reference,
          componentRefId,
        },
      };
    }

    case Types.CLOSE_EDIT_OBSOLESCENCE_MODAL: {
      return {
        ...state,
        editObsolescenceModal: {
          isOpen: false,
          obsolescenceFlat: undefined,
          versionId: undefined,
          reference: undefined,
          componentRefId: undefined,
        },
      };
    }

    default: {
      return state;
    }
  }
};

const UIProvider: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(UIReducer, initialState);

  const setItems = React.useCallback(
    (items: Item[]) => dispatch({ type: Types.SET_ITEMS, payload: { items } }),
    [dispatch]
  );

  const setTagNames = React.useCallback(
    (tagNames: string[]) => dispatch({ type: Types.SET_TAG_NAMES, payload: { tagNames } }),
    [dispatch]
  );

  const openTab = React.useCallback(
    (applicationId: number, applicationName: string) =>
      dispatch({ type: Types.OPEN_TAB, payload: { applicationId, applicationName } }),
    [dispatch]
  );

  const closeTab = React.useCallback(
    (applicationId: number) => dispatch({ type: Types.CLOSE_TAB, payload: { applicationId } }),
    [dispatch]
  );

  const hydrateTabs = React.useCallback(
    (tabs: IApplicationTab[]) => dispatch({ type: Types.HYDRATE_TABS, payload: { tabs } }),
    [dispatch]
  );

  const openScopeModal = React.useCallback(
    (
      applicationId: number | null | undefined,
      applicationName: string | null | undefined,
      scope: string | null | undefined,
      parent: string | null | undefined,
      date: string | null | undefined
    ) => dispatch({ type: Types.OPEN_SCOPE_MODAL, payload: { applicationId, applicationName, parent, scope, date } }),
    [dispatch]
  );

  const closeScopeModal = React.useCallback(() => dispatch({ type: Types.CLOSE_SCOPE_MODAL, payload: {} }), [dispatch]);

  const openBookmarkModal = React.useCallback(
    (userId: number, query: string) => dispatch({ type: Types.OPEN_BOOKMARK_MODAL, payload: { userId, query } }),
    [dispatch]
  );

  const closeBookmarkModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_BOOKMARK_MODAL, payload: {} }),
    [dispatch]
  );

  const openCostModal = React.useCallback(
    (applicationId: string | null | undefined, applicationName: string | null | undefined) =>
      dispatch({
        type: Types.OPEN_COST_MODAL,
        payload: { applicationId, applicationName },
      }),
    [dispatch]
  );

  const closeCostModal = React.useCallback(() => dispatch({ type: Types.CLOSE_COST_MODAL, payload: {} }), [dispatch]);

  const openConfirmModal = React.useCallback(
    (applicationId: number, applicationName: string) =>
      dispatch({ type: Types.OPEN_CONFIRM_MODAL, payload: { applicationId, applicationName } }),
    [dispatch]
  );

  const closeConfirmModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_CONFIRM_MODAL, payload: {} }),
    [dispatch]
  );

  const toggleFilters = React.useCallback(() => dispatch({ type: Types.TOGGLE_FILTERS, payload: {} }), [dispatch]);

  const toggleBookmark = React.useCallback(() => dispatch({ type: Types.TOGGLE_BOOKMARK, payload: {} }), [dispatch]);

  const openShareBookmarkModal = React.useCallback(
    (bookmarkId: number | undefined, url: string | undefined) =>
      dispatch({ type: Types.OPEN_SHARE_BOOKMARK_MODAL, payload: { bookmarkId, url } }),
    [dispatch]
  );

  const closeShareBookmarkModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_SHARE_BOOKMARK_MODAL, payload: {} }),
    [dispatch]
  );

  const openEditProfileModal = React.useCallback(
    (userId: number | undefined) => dispatch({ type: Types.OPEN_EDIT_PROFILE_MODAL, payload: { userId } }),
    [dispatch]
  );

  const closeEditProfileModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_EDIT_PROFILE_MODAL, payload: {} }),
    [dispatch]
  );

  const setFilters = React.useCallback(
    (isOpen: boolean) => dispatch({ type: Types.SET_FILTERS, payload: { isOpen } }),
    [dispatch]
  );

  const setBookmark = React.useCallback(
    (isOpen: boolean) => dispatch({ type: Types.SET_BOOKMARK, payload: { isOpen } }),
    [dispatch]
  );

  const setPeriodView = React.useCallback(
    (periodView: PERIOD_VIEW) => dispatch({ type: Types.SET_PERIOD_VIEW, payload: { periodView } }),
    [dispatch]
  );

  const openSettingsModal = React.useCallback(
    (view: SETTINGS_VIEW) => dispatch({ type: Types.OPEN_SETTINGS_MODAL, payload: { view } }),
    [dispatch]
  );

  const closeSettingsModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_SETTINGS_MODAL, payload: {} }),
    [dispatch]
  );

  const openRemoveExceptionModal = React.useCallback(
    (exceptionId: number) => dispatch({ type: Types.OPEN_REMOVE_EXCEPTION_MODAL, payload: { exceptionId } }),
    [dispatch]
  );

  const closeRemoveExceptionModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_REMOVE_EXCEPTION_MODAL, payload: {} }),
    [dispatch]
  );

  const openRemoveRoadmapModal = React.useCallback(
    (roadmapId: number | undefined) => dispatch({ type: Types.OPEN_REMOVE_ROADMAP_MODAL, payload: { roadmapId } }),
    [dispatch]
  );

  const closeRemoveRoadmapModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_REMOVE_ROADMAP_MODAL, payload: {} }),
    [dispatch]
  );

  const openRemoveTagModal = React.useCallback(
    (tagId: number | undefined) => dispatch({ type: Types.OPEN_REMOVE_TAG_MODAL, payload: { tagId } }),
    [dispatch]
  );

  const closeRemoveTagModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_REMOVE_TAG_MODAL, payload: {} }),
    [dispatch]
  );

  const openRemoveBookmarkModal = React.useCallback(
    (bookmarkId: number | undefined) => dispatch({ type: Types.OPEN_REMOVE_BOOKMARK_MODAL, payload: { bookmarkId } }),
    [dispatch]
  );

  const closeRemoveBookmarkModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_REMOVE_BOOKMARK_MODAL, payload: {} }),
    [dispatch]
  );

  const openRoadmapActionModal = React.useCallback(
    (roadmapId: number | undefined, roadmapActions: Array<RoadmapAction>) =>
      dispatch({
        type: Types.OPEN_ROADMAP_ACTION_MODAL,
        payload: {
          roadmapId,
          actions: roadmapActions,
        },
      }),
    [dispatch]
  );

  const closeRoadmapActionModal = React.useCallback(
    () =>
      dispatch({
        type: Types.CLOSE_ROADMAP_ACTION_MODAL,
        payload: {},
      }),
    [dispatch]
  );

  const openCertificationErrorModal = React.useCallback(
    (componentStatusIds: number[], componentIds: number[]) =>
      dispatch({
        type: Types.OPEN_CERTIFICATION_ERROR_MODAL,
        payload: { componentStatusIds, componentIds },
      }),
    [dispatch]
  );

  const closeCertificationErrorModal = React.useCallback(
    () =>
      dispatch({
        type: Types.CLOSE_CERTIFICATION_ERROR_MODAL,
        payload: {},
      }),
    [dispatch]
  );

  const openTagModal = React.useCallback(() => dispatch({ type: Types.OPEN_TAG_MODAL, payload: {} }), [dispatch]);

  const closeTagModal = React.useCallback(() => dispatch({ type: Types.CLOSE_TAG_MODAL, payload: {} }), [dispatch]);

  const setSettingsView = React.useCallback(
    (view: SETTINGS_VIEW) => dispatch({ type: Types.SET_SETTINGS_VIEW, payload: { view } }),
    [dispatch]
  );

  const openClaimModal = React.useCallback(() => dispatch({ type: Types.OPEN_CLAIM_MODAL, payload: {} }), [dispatch]);

  const closeClaimModal = React.useCallback(() => dispatch({ type: Types.CLOSE_CLAIM_MODAL, payload: {} }), [dispatch]);

  const openEditObsolescenceModal = React.useCallback(
    (payload: {
      obsolescenceFlat: Obsolescence.ObsolescenceFlat | undefined;
      reference: Obsolescence.Reference | undefined;
      componentRefId: number | undefined;
      versionId: number;
      onUpdate: () => void;
    }) => dispatch({ type: Types.OPEN_EDIT_OBSOLESCENCE_MODAL, payload }),
    [dispatch]
  );

  const closeEditObsolescenceModal = React.useCallback(
    () => dispatch({ type: Types.CLOSE_EDIT_OBSOLESCENCE_MODAL, payload: {} }),
    [dispatch]
  );

  const value = React.useMemo(
    () => ({
      ...state,
      setItems,
      setTagNames,
      openClaimModal,
      closeClaimModal,
      openTab,
      closeTab,
      hydrateTabs,
      openScopeModal,
      closeScopeModal,
      openBookmarkModal,
      closeBookmarkModal,
      openConfirmModal,
      closeConfirmModal,
      toggleFilters,
      toggleBookmark,
      setFilters,
      setBookmark,
      openSettingsModal,
      closeSettingsModal,
      openRemoveExceptionModal,
      closeRemoveExceptionModal,
      openRemoveRoadmapModal,
      closeRemoveRoadmapModal,
      openRemoveTagModal,
      closeRemoveTagModal,
      openRemoveBookmarkModal,
      closeRemoveBookmarkModal,
      openRoadmapActionModal,
      closeRoadmapActionModal,
      openCostModal,
      closeCostModal,
      openCertificationErrorModal,
      closeCertificationErrorModal,
      openTagModal,
      closeTagModal,
      setSettingsView,
      setPeriodView,
      openShareBookmarkModal,
      closeShareBookmarkModal,
      openEditProfileModal,
      closeEditProfileModal,
      openEditObsolescenceModal,
      closeEditObsolescenceModal,
    }),
    [
      state,
      setItems,
      setTagNames,
      openClaimModal,
      closeClaimModal,
      openTab,
      closeTab,
      hydrateTabs,
      openScopeModal,
      closeScopeModal,
      openBookmarkModal,
      closeBookmarkModal,
      openCostModal,
      closeCostModal,
      openConfirmModal,
      closeConfirmModal,
      toggleFilters,
      toggleBookmark,
      setFilters,
      setBookmark,
      openSettingsModal,
      closeSettingsModal,
      openRemoveExceptionModal,
      closeRemoveExceptionModal,
      openRemoveRoadmapModal,
      closeRemoveRoadmapModal,
      openRemoveTagModal,
      closeRemoveTagModal,
      openRemoveBookmarkModal,
      closeRemoveBookmarkModal,
      openRoadmapActionModal,
      closeRoadmapActionModal,
      openCertificationErrorModal,
      closeCertificationErrorModal,
      openTagModal,
      closeTagModal,
      setSettingsView,
      setPeriodView,
      openShareBookmarkModal,
      closeShareBookmarkModal,
      openEditProfileModal,
      closeEditProfileModal,
      openEditObsolescenceModal,
      closeEditObsolescenceModal,
    ]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
};

export const useUI = (): {
  setItems: (items: Item[]) => void;
  setTagNames: (tagNames: string[]) => void;
  openClaimModal: () => void;
  closeClaimModal: () => void;
  openTab: (applicationId: number, applicationName: string) => void;
  closeTab: (applicationId: number) => void;
  hydrateTabs: (tabs: IApplicationTab[]) => void;
  openScopeModal: (
    applicationId: number | null | undefined,
    applicationName: string | null | undefined,
    scope: string | null | undefined,
    parent: string | null | undefined,
    date: string | null | undefined
  ) => void;
  closeScopeModal: () => void;
  openBookmarkModal: (userId: number | undefined, query: string | null | undefined) => void;
  closeBookmarkModal: () => void;
  openEditProfileModal: (userId: number | undefined) => void;
  closeEditProfileModal: () => void;
  openCostModal: (
    applicationId: number | string | null | undefined,
    applicationName: string | null | undefined
  ) => void;
  closeCostModal: () => void;
  openConfirmModal: (applicationId: number, applicationName: string) => void;
  closeConfirmModal: () => void;
  toggleFilters: () => void;
  toggleBookmark: () => void;
  openShareBookmarkModal: (bookmarkId: number, url: string | undefined) => void;
  closeShareBookmarkModal: () => void;
  setFilters: (isOpen: boolean) => void;
  setBookmark: (isOpen: boolean) => void;
  setPeriodView: (periodView: PERIOD_VIEW) => void;
  openSettingsModal: (view: SETTINGS_VIEW) => void;
  closeSettingsModal: () => void;
  openRemoveExceptionModal: (exceptionId: number) => void;
  closeRemoveExceptionModal: () => void;
  openRemoveRoadmapModal: (roadmapId: number | undefined) => void;
  closeRemoveRoadmapModal: () => void;
  openRemoveTagModal: (tagId: number | undefined) => void;
  closeRemoveTagModal: () => void;
  openRemoveBookmarkModal: (bookmarkId: number | undefined) => void;
  closeRemoveBookmarkModal: () => void;
  openRoadmapActionModal: (roadmapId: number | undefined, roadmapActions: Array<RoadmapAction>) => void;
  closeRoadmapActionModal: () => void;
  openCertificationErrorModal: (componentStatusIds: number[], componentIds: number[]) => void;
  closeCertificationErrorModal: () => void;
  openTagModal: () => void;
  closeTagModal: () => void;
  setSettingsView: (view: SETTINGS_VIEW) => void;
  openEditObsolescenceModal: (payload: {
    obsolescenceFlat: Obsolescence.ObsolescenceFlat | undefined;
    reference: Obsolescence.Reference | undefined;
    componentRefId: number | undefined;
    versionId: number | undefined;
  }) => void;
  closeEditObsolescenceModal: () => void;
} & InitialStateType => {
  const context = React.useContext(UIContext);

  if (typeof context === 'undefined') {
    throw new Error(`useUI must be used within an UIProvider`);
  }

  return context;
};

export { UIContext, UIProvider };
